/**
*****************************************
*										*
* NAGARRO  - CSX - CONFIDENTIAL         *
*										*
*****************************************
*/

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TreeTableModule } from 'primeng/treetable';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SplitButtonModule } from 'primeng/splitbutton';

import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { LmsTrainDataContainerComponent } from './data/lms-train-data-container/lms-train-data-container.component';
import { LmsTrainDetailsComponent } from './data/lms-train-details/lms-train-details.component';
import { LmsTrainInformationComponent } from './data/lms-train-information/lms-train-information.component';
import { LmsTrainLocoDetailsDataComponent } from './data/lms-train-loco-details-data/lms-train-loco-details-data.component';
import { LmsTrainLocoDetailsHeaderComponent } from './data/lms-train-loco-details-header/lms-train-loco-details-header.component';
import { LmsTrainPtcComponent } from './data/lms-train-ptc/lms-train-ptc.component';
import { LmsTrainRouteComponent } from './data/lms-train-route/lms-train-route.component';
import { LmsTrainTopActionsComponent } from './data/lms-train-top-actions/lms-train-top-actions.component';
import { LmsTrainDataComponent } from './data/train-data.component';
import { TrainHistoryDetailsComponent } from './history/train-history-details/train-history-details.component';
import { TrainHistoryHeaderComponent } from './history/train-history-header/train-history-header.component';
import { LmsTrainHistoryComponent } from './history/train-history.component';
import { LmsTrainNotesComponent } from './notes/train-notes.component';
import { LocoBlankString } from './pipes/loco-blank-string.pipe';
import { LocoSortPipe } from './pipes/loco-sort.pipe';
import { LmsTrainProfileComponent } from './profile/train-profile.component';
import { TrainDataService } from './services/train-data.service';
import { TrainHistoryService } from './services/train-history.service';
import { TrainProfileService } from './services/train-profile.service';
import { TrainDataResolver } from './shared/train-data.resolver';
import { TrainHistoryResolver } from './shared/train-history.resolver';
import { TrainNotesResolver } from './shared/train-notes.resolver';
import { TrainProfileResolver } from './shared/train-profile.resolver';
import { TrainRoutingModule } from './train-routing.module';
import { LmsTrainComponent } from './train.component';


/**
 * This TrainModule is created for all train information related screens.s
 * @export
 * @class TrainModule
 */
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        CoreModule,
        OverlayPanelModule,
        DropdownModule,
        AutoCompleteModule,
        RadioButtonModule,
        SplitButtonModule,
        ReactiveFormsModule,
        CalendarModule,
        DialogModule,
        FormsModule,
        TreeTableModule,
        InputTextareaModule,
        TrainRoutingModule
    ],
    providers: [TrainNotesResolver, TrainDataService, TrainHistoryService, TrainDataResolver, TrainHistoryResolver, TrainProfileResolver, TrainProfileService],
    declarations: [LmsTrainComponent, LmsTrainTopActionsComponent,
        LmsTrainDataContainerComponent, LocoSortPipe, LmsTrainRouteComponent,
        LmsTrainInformationComponent, LmsTrainDetailsComponent, LmsTrainLocoDetailsHeaderComponent,
        LmsTrainLocoDetailsDataComponent,
        LmsTrainPtcComponent,
        LmsTrainDataComponent,
        LmsTrainHistoryComponent,
        LmsTrainNotesComponent,
        LmsTrainProfileComponent,
        TrainHistoryHeaderComponent,
        LocoBlankString,
        TrainHistoryDetailsComponent],
    exports: [LmsTrainComponent, LocoSortPipe]
})

export class TrainModule { }
